
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-granth-bussiness-office-rep-indetails',
  templateUrl: './granth-bussiness-office-rep-indetails.component.html',
  styleUrl: './granth-bussiness-office-rep-indetails.component.scss'
})
export class GranthBussinessOfficeRepIndetailsComponent implements OnInit {

  report: any[] = [];
  grandTotals: any = {};

  startDate: any;
  endDate: any;
  today: Date = new Date();

  private readonly STORAGE_KEY = 'business_report_41';

  constructor(
    private service: DigisubservicesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;

    this.loadReport({
      start_date: this.startDate,
      end_date: this.endDate,
      office_rep_name: this.data?.office_rep_name || null
    });
  }

  /* ================= API ================= */
  loadReport(payload: any) {
    this.service.getgranthBusinessReportrepwise(payload).subscribe((res: any) => {

      if (!res || res.status !== 'success') return;

      this.report = res.data || [];
      this.grandTotals = res.grand_totals || {};

      this.report.forEach(group => {
        group.rows.forEach((row: any) => {
          row.total_amt        = +row.total_amt        || 0;
          row.invoice_total    = +row.invoice_total    || 0;
          row.total_amt1       = +row.total_amt1       || 0;
          row.prev_unpaid_amt  = +row.prev_unpaid_amt  || 0;
          row.total_unpaid_amt = +row.total_unpaid_amt || 0;

          // ✅ load saved values from localStorage
          const saved = this.getFromLocalStorage(row.rep_name);
          row.target_amt = saved?.target_amt ?? (+row.target_amt || 0);
          row.other_amt  = saved?.other_amt  ?? (+row.other_amt  || 0);

          // ✅ derived field
          row.total_received_amt = (row.total_amt1 || 0) + (row.other_amt || 0);

          // ✅ per-row येणे बाकी total
          row.total_yene_baki = (row.prev_unpaid_amt || 0) + (row.total_unpaid_amt || 0);
        });
      });

      this.recalculateGrandTotals();
    });
  }
  getFinancialYear(start: any, end: any): string {
  if (!start || !end) return 'FY';

  const s = new Date(start);
  const e = new Date(end);

  const startYear = s.getFullYear();
  const endYear = e.getFullYear();

  return `${startYear}-${endYear}`;
}
getPreviousYearRangeLabel(startYear: any, endDate: any): string {

  if (!startYear || !endDate) {
    return 'एकूण 2024 ते 2025';
  }

  const end = new Date(endDate);

  let startY = Number(startYear);   // 🔥 treat as YEAR directly
  let endY = end.getFullYear();

  // optional FY adjustment
  if (end.getMonth() < 3) {
    endY--;
  }

  return ` ${startY} ते ${endY}`;
}

  /* ================= LOCAL STORAGE ================= */

  private buildKey(name: string): string {
    return `${this.STORAGE_KEY}_${name}_${this.startDate}_${this.endDate}`;
  }

  private saveToLocalStorage(row: any): void {
    if (!row?.office_rep_name) return;
    const key = this.buildKey(row.office_rep_name);
    localStorage.setItem(key, JSON.stringify({
      target_amt: row.target_amt || 0,
      other_amt:  row.other_amt  || 0
    }));
  }

  private getFromLocalStorage(name: string): any {
    const key = this.buildKey(name);
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch { return null; }
  }

  /* ================= CHANGE EVENTS ================= */

  onTargetChange(row: any) {
    row.target_amt = +row.target_amt || 0;
    this.saveToLocalStorage(row);
    this.recalculateGrandTotals();
  }

  onAmountChange(row: any) {
    row.other_amt = +row.other_amt || 0;

    // ✅ recalculate derived fields
    row.total_received_amt = (row.total_amt1 || 0) + (row.other_amt || 0);
    row.total_yene_baki    = (row.prev_unpaid_amt || 0) + (row.total_unpaid_amt || 0);

    this.saveToLocalStorage(row);
    this.recalculateGrandTotals();
  }

  /* ================= GRAND TOTALS ================= */

  recalculateGrandTotals(): void {
    this.grandTotals = {
      target_amt:         0,
      invoice_total:      0,
      total_amt1:         0,
      other_amt:          0,
      total_received_amt: 0,
      prev_unpaid_amt:    0,
      total_unpaid_amt:   0,
      total_yene_baki:    0   // ✅ grand total of एकूण येणे बाकी
    };

    this.report.forEach(group => {
      group.rows.forEach((row: any) => {
        this.grandTotals.target_amt         += +row.target_amt         || 0;
        this.grandTotals.invoice_total      += +row.invoice_total      || 0;
        this.grandTotals.total_amt1         += +row.total_amt1         || 0;
        this.grandTotals.other_amt          += +row.other_amt          || 0;
        this.grandTotals.total_received_amt += +row.total_received_amt || 0;
        this.grandTotals.prev_unpaid_amt    += +row.prev_unpaid_amt    || 0;
        this.grandTotals.total_unpaid_amt   += +row.total_unpaid_amt   || 0;
        // ✅ sum of (prev + current) per row = correct grand total येणे बाकी
        this.grandTotals.total_yene_baki    += (+row.prev_unpaid_amt || 0) + (+row.total_unpaid_amt || 0);
      });
    });
  }

  /* ================= SERIAL NUMBER ================= */

  getSerialNumber(groupIndex: number, rowIndex: number): number {
    let count = 0;
    for (let i = 0; i < groupIndex; i++) {
      count += this.report[i].rows.length;
    }
    return count + rowIndex + 1;
  }

  /* ================= PERCENTAGE ================= */

  getPercentage(value: number): number {
    return this.grandTotals.invoice_total
      ? (value / this.grandTotals.invoice_total) * 100
      : 0;
  }

  /* ================= PRINT ================= */

  printReportA3() {
    const printContent = document.getElementById('print-section');
    if (!printContent) return;

    const cloned = printContent.cloneNode(true) as HTMLElement;

    // ✅ Replace inputs with text spans
    cloned.querySelectorAll('input').forEach((input: HTMLInputElement) => {
      const span = document.createElement('span');
      span.textContent = input.value || '0';
      span.style.display = 'inline-block';
      span.style.width = input.style.width || '80px';
      span.style.textAlign = 'right';
      input.replaceWith(span);
    });

    // ✅ Find and style grand total row
    const rows = cloned.querySelectorAll('tr');
    let grandTotalRow: HTMLElement | null = null;

    rows.forEach(row => {
      if ((row.textContent || '').includes('एकूण')) {
        grandTotalRow = row as HTMLElement;
      }
    });

    if (grandTotalRow) {
      grandTotalRow.style.backgroundColor = '#00d2d2';
      grandTotalRow.style.fontWeight = 'bold';

      const cells = grandTotalRow.querySelectorAll('td');
      cells.forEach(td => {
        td.style.backgroundColor = '#00d2d2';
        td.style.fontWeight = 'bold';
        td.style.textAlign = 'right';
      });

      const formatNum = (n: number) => Number(n || 0).toLocaleString('en-IN');

      if (cells[2])  cells[2].textContent  = formatNum(this.grandTotals.target_amt);
      if (cells[3])  cells[3].textContent  = formatNum(this.grandTotals.invoice_total);
            if (cells[5])  cells[5].textContent  = formatNum(this.grandTotals.other_amt);
      if (cells[6])  cells[6].textContent  = formatNum(this.grandTotals.total_amt1);
      // if (cells[6])  cells[6].textContent  = formatNum(this.grandTotals.other_amt);
      if (cells[7])  cells[7].textContent  = formatNum(this.grandTotals.total_received_amt);
      if (cells[8])  cells[8].textContent  = formatNum(this.grandTotals.prev_unpaid_amt);
      if (cells[9])  cells[9].textContent  = formatNum(this.grandTotals.total_unpaid_amt);
      if (cells[10]) {
        cells[10].textContent = formatNum(this.grandTotals.total_yene_baki);
        cells[10].style.fontWeight = 'bold';
        cells[10].style.backgroundColor = '#00d2d2';
      }
    }

    const win = window.open('', '', 'width=1400,height=900');
    if (win) {
      win.document.write(`
        <html>
        <head>
          <style>
            @page { size: A3 landscape; margin: 5mm; }
            body { font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid black; padding: 5px; }
            tr td { vertical-align: middle; }
          </style>
        </head>
        <body>${cloned.innerHTML}</body>
        </html>
      `);
      win.document.close();
      win.focus();
      win.print();
      win.close();
    }
  }

  /* ================= EXPORT ================= */

  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    const table = element.querySelector('table:last-child') as HTMLElement;
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, fileName + '.xlsx');
  }
}